import React from 'react'
import ExpensesTransactions from 'src/app/ExpensesTransactions/ExpensesTransactions'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesTransactionsRouteProps } from 'src/navigation/routeProps'

const ExpensesTransactionsAppRoute: AppRoute = {
  id: AppLocation.CardTransactions,
  routeProps: expensesTransactionsRouteProps,
  component: <ExpensesTransactions />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesTransactionsAppRoute
